import { useEffect, useMemo, useState } from 'react';

const DEFAULT_PAGE_SIZE = 10;

interface UsePaginationOptions {
  pageSize?: number;
}

export function usePagination<T>(items: T[], options?: UsePaginationOptions) {
  const pageSize = options?.pageSize ?? DEFAULT_PAGE_SIZE;
  const [currentPage, setCurrentPage] = useState(0);

  const totalPages = Math.ceil(items.length / pageSize);

  // Reset to first page when the dataset changes
  useEffect(() => {
    setCurrentPage(0);
  }, [items.length]);

  const paginatedItems = useMemo(() => {
    const start = currentPage * pageSize;
    return items.slice(start, start + pageSize);
  }, [items, currentPage, pageSize]);

  const page = useMemo(
    () => ({
      number: currentPage,
      totalPages,
      totalElements: items.length,
      size: pageSize,
    }),
    [currentPage, totalPages, items.length, pageSize]
  );

  return { paginatedItems, page, setCurrentPage, pageSize };
}
